import SVG from 'react-inlinesvg'
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

/**
 * Renders a tooltip button component.
 *
 * @param {string} title - The title of the tooltip.
 * @param {string} icon - The icon to be displayed.
 * @param {function} onClick - The event handler for the button click.
 * @return {JSX.Element} The rendered tooltip button component.
 */
const TooltipButton=({ title, icon, onClick })=> {
    return (
        <Tooltip title={title}>
            <IconButton onClick={onClick}>
                <SVG src={icon} style={{ width: 24, height: 24 }} />
            </IconButton>
        </Tooltip>
    )
}

export default TooltipButton;